import { render, staticRenderFns } from "./TerrainReviewQueue.vue?vue&type=template&id=73f071da&scoped=true"
import script from "./TerrainReviewQueue.vue?vue&type=script&lang=js"
export * from "./TerrainReviewQueue.vue?vue&type=script&lang=js"
import style0 from "./TerrainReviewQueue.vue?vue&type=style&index=0&id=73f071da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f071da",
  null
  
)

export default component.exports